const safetyItems = [
  { icon: 'ri-shield-check-line', label: 'Verified System' },
  { icon: 'ri-lock-line', label: 'Secure Access' },
  { icon: 'ri-eye-line', label: 'Full Transparency' },
  { icon: 'ri-check-double-line', label: 'User Control' },
];

export default function Safety() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" id="safety">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          {/* Left */}
          <div className="lg:w-1/3">
            <span className="text-xs font-medium text-foreground-500 tracking-widest uppercase">
              / Safety
            </span>
            <span className="block mt-6 text-xs text-foreground-400 font-medium">· Verified System</span>
          </div>

          {/* Right */}
          <div className="lg:w-2/3">
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 font-light leading-[1.25]">
              Safe &amp; Transparent Sourcing
            </h2>

            {/* Trust icons */}
            <div className="flex flex-wrap items-center gap-6 mt-8">
              {safetyItems.map((item) => (
                <div key={item.label} className="flex items-center gap-2.5">
                  <span className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-secondary-600 text-lg`}></i>
                  </span>
                  <span className="text-sm text-foreground-700 font-medium">{item.label}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { title: 'No Hidden Payments', desc: 'No charges inside the spreadsheet system itself. Educational and organizational use only.' },
                { title: 'Scam Awareness', desc: 'Built-in guidelines help newer resellers avoid common sourcing traps and unreliable suppliers.' },
                { title: 'Full User Control', desc: 'You maintain complete control over every sourcing decision at all times.' },
                { title: 'Transparent Data', desc: 'Product data is organized clearly with no misleading or manipulated information.' },
              ].map((item) => (
                <div key={item.title} className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                  <h4 className="text-sm font-semibold text-foreground-950 mb-1.5">{item.title}</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}